// src/components/Common/GlobalHardReload.jsx
import { Fab, Tooltip, Box } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

export default function HardReloadButton() {
    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: { xs: 16, sm: 24 },
                right: { xs: 16, sm: 32 },
                zIndex: 1300,
            }}
        >
            <Tooltip title="강력 새로고침 (Ctrl + Shift + R)">
                <Fab
                    color="primary"
                    size="medium"
                    sx={{ boxShadow: 3 }}
                    onClick={() => window.location.reload(true)}
                >
                    <RestartAltIcon />
                </Fab>
            </Tooltip>
        </Box>
    );
}